import { endPoints, requestType } from "../lib/variable";
import Api from "./index"
const loginUser = (payload) => {
    return Api(endPoints.adminLogin, payload, requestType.POST);
};

const changePassword = (payload) => {
    return Api(endPoints.passwordChange, payload, requestType.POST);
};



export {
    loginUser,
    changePassword
}